import { useState, useEffect } from 'react'
import Question from './Question'
import {
    FaqTitle,
    FaqContainer,
    Welcome,
    Answer,
    AnswerSubtitle,
    AnswerList,
    AnswerListElement,
    ContactLink,
    DownloadLink,
} from './FaqElement'
import {
    Record,
    RecordCircle,
    ArrowCircleUp,
    Triangle,
    Component,
    Diamonds,
    Shield,
    ShieldTick,
    Star,
    Star1,
    Medal,
    MedalStar,
    Award,
    Crown,
    Crown1,
} from 'iconsax-react'
import { ReactComponent as King } from '../../../images/king.svg'
import Footer from '../../Footer'

const Faq = () => {
    const [activeQuestionId, setActiveQuestionId] = useState()

    useEffect(() => {
        const applyHash = () => {
            const id = window.location.hash.replace('#', '')
            if (!id) {
                setActiveQuestionId(undefined)
                return
            }
            setActiveQuestionId(id)
            const element = document.getElementById(id)
            element && element.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
                inline: 'start'
            })
        }

        applyHash()
        window.addEventListener('hashchange', applyHash)
        return () => window.removeEventListener('hashchange', applyHash)
    }, [])

    return (
        <>
            <FaqContainer>
                <FaqTitle>
                    Foire aux questions
                </FaqTitle>
                <Welcome> Bienvenue sur Djado </Welcome>

                <Question
                    questionId='about'
                    activeQuestionId={activeQuestionId}
                    setActiveQuestionId={setActiveQuestionId}
                    content="Qu'est-ce que Djado ?"
                >
                    <Answer>
                        Djado est une application mobile, accessible dès 13 ans, qui célèbre la culture africaine 🌍.
                        Quiz, défis quotidiens, duels en temps réel et tournois sponsorisés : Djado, c'est l'app qui transforme votre culture en aventure.
                    </Answer>
                    <Answer>
                        Histoire, géographie, musique, cinéma, gastronomie, sport, littérature, faune, flore... <b>plus de 15 thématiques</b> pour explorer le continent dans toute sa diversité.
                    </Answer>
                </Question>

                <Question
                    questionId='pricing'
                    activeQuestionId={activeQuestionId}
                    setActiveQuestionId={setActiveQuestionId}
                    content="L'app est-elle gratuite ?"
                >
                    <Answer>
                        Oui, Djado est entièrement gratuit au téléchargement et au jeu. Tous les modes et le contenu quotidien sont accessibles librement.
                    </Answer>
                    <Answer>
                        La monnaie de l'app, ce sont les <b>pièces d'or</b>, que vous gagnez en jouant. Elles vous permettent d'acheter des <b>jokers</b> pour vous aider à résoudre les quiz les plus corsés. Aucun achat avec de l'argent réel n'est requis.
                    </Answer>
                </Question>

                <Question
                    questionId='name'
                    activeQuestionId={activeQuestionId}
                    setActiveQuestionId={setActiveQuestionId}
                    content="D'où vient le nom Djado ?"
                >
                    <Answer>
                        Le nom « Djado » a deux racines.
                    </Answer>
                    <Answer>
                        D'abord, l'illustre historien et conteur <b>Djado Sékou</b>, dont la voix incarne la transmission orale africaine.
                    </Answer>
                    <Answer>
                        Ensuite, le <b>Plateau du Djado</b> : un massif spectaculaire au Nord-Est du Niger, terre de mémoires sahariennes.
                    </Answer>
                    <Answer>
                        Deux symboles, une seule promesse : raconter l'Afrique, du quotidien aux profondeurs de l'Histoire.
                    </Answer>
                </Question>

                <Question
                    questionId='sekou'
                    activeQuestionId={activeQuestionId}
                    setActiveQuestionId={setActiveQuestionId}
                    content="Qui est Sékou ?"
                >
                    <Answer>
                        Sékou est notre conteur attitré, le visage et la voix de Djado.
                    </Answer>
                    <Answer>
                        Inspiré du légendaire Djado Sékou, il vous accompagne chaque matin avec votre dose de culture : Mémoires d'Afrique, proverbes, anecdotes, faits méconnus...
                    </Answer>
                    <Answer>
                        Pensez à lui comme à un griot des temps modernes, bienveillant et un peu malicieux 😉
                    </Answer>
                </Question>

                <Question
                    questionId='game-modes'
                    activeQuestionId={activeQuestionId}
                    setActiveQuestionId={setActiveQuestionId}
                    content="Quels modes de jeu existent sur Djado ?"
                >
                    <AnswerList>
                        Plusieurs modes pour jouer comme vous voulez :
                        <AnswerListElement>
                            <b>Question du jour</b> &amp; <b>Devinette du jour</b> : deux nouveaux défis chaque matin.
                        </AnswerListElement>
                        <AnswerListElement>
                            <b>Ligue</b> : duels 1v1 en temps réel. Mesurez-vous aux meilleurs joueurs et grimpez dans le classement saisonnier.
                        </AnswerListElement>
                        <AnswerListElement>
                            <b>Tournois</b> : compétitions à thème avec des récompenses à la clé. Inscrivez-vous, jouez, gagnez.
                        </AnswerListElement>
                        <AnswerListElement>
                            <b>Sans faute</b> : alignez les bonnes réponses sans vous tromper. Jusqu'où irez-vous ?
                        </AnswerListElement>
                        <AnswerListElement>
                            <b>Découverte</b> : voyagez à travers le continent, série après série (pays, époques, figures...).
                        </AnswerListElement>
                        D'autres modes sont à venir, notamment <b>Entre amis</b>. Restez connectés 😉
                    </AnswerList>
                    <Answer>
                        Il existe 2 types de quiz : les <b>anagrammes</b> et les <b>QCM</b>.
                    </Answer>
                </Question>

                <Question
                    questionId='coins-and-jokers'
                    activeQuestionId={activeQuestionId}
                    setActiveQuestionId={setActiveQuestionId}
                    content="À quoi servent les pièces d'or et les jokers ?"
                >
                    <Answer>
                        Les <b>pièces d'or</b> sont la monnaie virtuelle de Djado. Vous en gagnez en répondant aux défis quotidiens, en remportant des matchs en Ligue, en participant à des tournois, en parrainant vos proches ou en contribuant au contenu de l'app.
                    </Answer>
                    <AnswerList>
                        Avec ces pièces, vous achetez des <b>jokers</b> à la Boutique :
                        <AnswerListElement>
                            🃏 <b>Indice</b> : voyez tous les indices d'un quiz.
                        </AnswerListElement>
                        <AnswerListElement>
                            ⏳ <b>Sablier</b> : prolongez le temps de réflexion.
                        </AnswerListElement>
                        <AnswerListElement>
                            🔤 <b>1ère lettre</b> : découvrez la première lettre de la réponse (anagrammes uniquement).
                        </AnswerListElement>
                    </AnswerList>
                    <Answer>
                        Les jokers se déclenchent à la demande, en cours de partie. Une seule règle : ne pas en abuser, sinon où est le défi 😉
                    </Answer>
                </Question>

                <Question
                    questionId='levels'
                    activeQuestionId={activeQuestionId}
                    setActiveQuestionId={setActiveQuestionId}
                    content="Quels sont les différents niveaux d'avancement ?"
                >
                    <Answer>
                        Il existe 16 niveaux, échelonnés en fonction du nombre d'XP. Les 8 premiers rendent hommage aux griots, gardiens de la tradition orale africaine. Les 8 suivants célèbrent les souverains qui ont marqué l'histoire du continent.
                    </Answer>

                    <AnswerSubtitle>🎙️ Griots — gardiens de la tradition orale</AnswerSubtitle>
                    <AnswerList>
                        <AnswerListElement>
                            0 - 49 XP: <b>Djeli</b> <Record size={16} /> : Griot en langues Mandingues
                        </AnswerListElement>
                        <AnswerListElement>
                            50 - 149 XP: <b>Gewel</b> <RecordCircle size={16} /> : Griot en Wolof
                        </AnswerListElement>
                        <AnswerListElement>
                            150 - 399 XP: <b>Djassar</b> <ArrowCircleUp size={16} /> : Griot en Zarma
                        </AnswerListElement>
                        <AnswerListElement>
                            400 - 999 XP: <b>Bambadô</b> <Triangle size={16} /> : Griot en Peul
                        </AnswerListElement>
                        <AnswerListElement>
                            1000 - 1999 XP: <b>Kumatigi</b> <Component size={16} /> : «&nbsp;Maître de la parole&nbsp;» en langues Mandingues
                        </AnswerListElement>
                        <AnswerListElement>
                            2000 - 3999 XP: <b>Korrow</b> <Diamonds size={16} /> : «&nbsp;Le plus vieux griot&nbsp;» en langues Mandingues
                        </AnswerListElement>
                        <AnswerListElement>
                            4000 - 6999 XP: <b>Kuntigi</b> <Shield size={16} /> : «&nbsp;Chef des griots&nbsp;» en langues Mandingues
                        </AnswerListElement>
                        <AnswerListElement>
                            7000 - 9999 XP: <b>Sarkin Tarihi</b> <ShieldTick size={16} /> : «&nbsp;Roi du récit&nbsp;» en Haoussa
                        </AnswerListElement>
                    </AnswerList>

                    <AnswerSubtitle>👑 Souverains — bâtisseurs d'Empires</AnswerSubtitle>
                    <AnswerList>
                        <AnswerListElement>
                            10000 - 12999 XP: <b>Mogho Naaba</b> <Medal size={16} /> : Empereur des Mossi (Burkina Faso)
                        </AnswerListElement>
                        <AnswerListElement>
                            13000 - 15999 XP: <b>Mai</b> <MedalStar size={16} /> : Souverain du Kanem-Bornu (Tchad, Niger, Nigeria, Cameroun)
                        </AnswerListElement>
                        <AnswerListElement>
                            16000 - 19999 XP: <b>Manikongo</b> <Star1 size={16} /> : Souverain du Royaume du Kongo (Angola, RDC, Congo)
                        </AnswerListElement>
                        <AnswerListElement>
                            20000 - 24999 XP: <b>Asantehene</b> <Star size={16} /> : Roi des Ashanti (Ghana)
                        </AnswerListElement>
                        <AnswerListElement>
                            25000 - 31999 XP: <b>Oba</b> <Award size={16} /> : Roi en Yoruba (Nigeria, Bénin, Togo)
                        </AnswerListElement>
                        <AnswerListElement>
                            32000 - 39999 XP: <b>Nkosi</b> <Crown size={16} /> : Roi en Zulu (Afrique du Sud)
                        </AnswerListElement>
                        <AnswerListElement>
                            40000 - 49999 XP: <b>Mansa</b> <Crown1 size={16} /> : Empereur du Mali, Mansa Musa (Mali, Sénégal, Mauritanie, Gambie, Guinée, Guinée-Bissau, Burkina Faso, Niger, Côte d'Ivoire)
                        </AnswerListElement>
                        <AnswerListElement>
                            À partir de 50000 XP: <b>Negusä Nägäst</b> <King width={16} height={16} /> : «&nbsp;Roi des rois&nbsp;» en Amharique, Empire éthiopien (Éthiopie, Érythrée)
                        </AnswerListElement>
                    </AnswerList>
                </Question>

                <Question
                    questionId='contests'
                    activeQuestionId={activeQuestionId}
                    setActiveQuestionId={setActiveQuestionId}
                    content="Concours et autres compétitions, quelles sont les règles ?"
                >
                    <Answer>
                        Sur Djado, les joueurs ont la possibilité de remporter des lots divers (espèce ou nature) en participant à des tournois par exemple.
                        Ces récompenses sont accordées aux joueurs les mieux classés sur lesdits tournois.
                        Une récompense similaire pourrait être mise en place pour les autres modes de jeux disponibles sur l'application.
                    </Answer>
                    <Answer>
                        Pour chaque compétition (tournoi, ligue, etc.) ABZYNE se réserve le droit de décerner ou non des prix (lots). Dans tous les cas, cette décision sera explicitée et connue de tous les participants bien avant le début de la compétition.
                        ABZYNE se réserve le droit de disqualifier tout joueur qui se rend coupable de fraude ou autres actes de nature à saboter le bon déroulement de la compétition ou à perturber le fonctionnement de l'application.
                        ABZYNE peut soumettre la remise du prix à certaines conditions. L'entreprise se réserve le droit d'imposer un mode de paiement (virement bancaire, mobile money, etc.) ou de livraison.
                    </Answer>
                    <Answer>
                        Toutes les compétitions organisées sur Djado sont sponsorisées par ABZYNE (Karim SAYABOU EI), le développeur de l'application.
                        ABZYNE est responsable de l'organisation, de la gestion et de la distribution des prix. Les prix peuvent être fournis par nos partenaires et sponsors, mais ceux-ci n'ont aucune responsabilité dans l'organisation ou la gestion des concours. Ces partenaires peuvent être mentionnés à titre indicatif.
                    </Answer>
                    <Answer>
                        Apple et Google ne sont ni sponsors, ni impliqués dans nos différentes compétitions.
                    </Answer>
                </Question>

                <Question
                    questionId='contribute'
                    activeQuestionId={activeQuestionId}
                    setActiveQuestionId={setActiveQuestionId}
                    content="Comment contribuer au contenu de Djado ?"
                >
                    <Answer>
                        Djado grandit grâce à sa communauté. Vous pouvez nous proposer :
                    </Answer>
                    <AnswerList>
                        <AnswerListElement>
                            Des <b>quiz</b> (QCM ou anagrammes)
                        </AnswerListElement>
                        <AnswerListElement>
                            Des <b>devinettes</b>
                        </AnswerListElement>
                        <AnswerListElement>
                            Des <b>proverbes, poèmes ou citations</b>
                        </AnswerListElement>
                        <AnswerListElement>
                            Des <b>faits historiques ou culturels</b> (Le saviez-vous ?, Mémoires d'Afrique)
                        </AnswerListElement>
                        <AnswerListElement>
                            Des <b>séries Découverte</b> (un pays, une époque, une figure...)
                        </AnswerListElement>
                        <AnswerListElement>
                            Des <b>idées de fonctionnalités</b>
                        </AnswerListElement>
                    </AnswerList>
                    <Answer>
                        🪙 Chaque contribution acceptée vous rapporte au moins <b>20 pièces d'or</b>, et votre profil est crédité chaque fois que votre contenu est utilisé dans l'app.
                    </Answer>
                    <Answer>
                        N'hésitez pas à nous <ContactLink to='/contact'> Contacter ❤️</ContactLink>
                    </Answer>
                </Question>

                <Question
                    questionId='account'
                    activeQuestionId={activeQuestionId}
                    setActiveQuestionId={setActiveQuestionId}
                    content="Comment supprimer mon compte ou télécharger mes données ?"
                >
                    <Answer>
                        Vous pouvez à tout moment <b>télécharger toutes vos données Djado</b>. Depuis l'app : <b>Plus → Compte → Actions → Télécharger mes données</b>. Vous recevrez une copie complète par email.
                    </Answer>
                    <Answer>
                        Vous pouvez également <b>supprimer définitivement votre compte</b>. Depuis l'app : <b>Plus → Compte → Actions → Supprimer mon compte</b>. Cette action est irréversible : profil, progression et toutes les données associées seront effacés.
                    </Answer>
                    <Answer>
                        Pour toute question liée à vos données personnelles, consultez notre <ContactLink to='/djado/privacy'>Politique de confidentialité</ContactLink> ou <ContactLink to='/contact'> Contactez-nous ❤️</ContactLink>
                    </Answer>
                </Question>

                <Question
                    questionId='partnership'
                    activeQuestionId={activeQuestionId}
                    setActiveQuestionId={setActiveQuestionId}
                    content="Professionnel, comment être partenaire, sponsor ou promouvoir mon entreprise ?"
                >
                    <Answer>
                        <b>Sponsoring de tournois, branded content, opérations sur mesure, dotations…</b> quel que soit votre format, on construit ensemble.
                    </Answer>
                    <Answer>
                        Djado, c'est une audience engagée autour de la culture africaine — un terrain idéal pour les marques qui veulent s'adresser à cette communauté avec sens.
                    </Answer>
                    <Answer>
                        N'hésitez pas à nous <ContactLink to='/contact'> Contacter ❤️</ContactLink>
                    </Answer>
                </Question>

                <Question
                    questionId='download'
                    activeQuestionId={activeQuestionId}
                    setActiveQuestionId={setActiveQuestionId}
                    content="Où télécharger Djado ?"
                >
                    <Answer>
                        Djado est disponible sur iOS et Android.
                    </Answer>
                    <Answer>
                        Téléchargez l'app sur <DownloadLink href='https://apps.apple.com/us/app/djado/id6502918814' target='_blank' rel='noopener noreferrer'>l'App Store</DownloadLink> ou sur <DownloadLink href='https://play.google.com/store/apps/details?id=com.abzyne.djado' target='_blank' rel='noopener noreferrer'>Google Play</DownloadLink>, et commencez à jouer.
                    </Answer>
                </Question>

            </FaqContainer>

            <Footer />
        </>
    )
}

export default Faq
